import React, { useState, useEffect } from 'react';
import Breadcrumb from '../../components/UI/Breadcrumb/Breadcrumb';
import './Invite.css';

const Invite = () => {
  const [inviteCode, setInviteCode] = useState('');
  const [inviteUrl, setInviteUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const breadcrumbItems = [
    { label: '首页', path: '/dashboard' },
    { label: '邀请好友送积分', path: null }
  ];

  useEffect(() => {
    fetchInviteCode();
  }, []);

  const fetchInviteCode = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/auth/invite_code', {
        method: 'GET',
        credentials: 'include',
      });

      const data = await response.json();

      if (data.code === 0 && data.data) {
        const code = data.data.inviteCode || data.data.invite_code || data.data;
        setInviteCode(code);
        // Generate invite URL - you may want to adjust this based on your domain
        setInviteUrl(`${window.location.origin}/register?invite=${code}`);
      } else {
        setError(data.msg || '获取邀请码失败');
      }
    } catch (error) {
      console.error('Error fetching invite code:', error);
      setError('网络错误，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(inviteUrl);
      alert('邀请链接已复制到剪贴板');
    } catch (error) {
      console.error('复制失败:', error);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = inviteUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      alert('邀请链接已复制到剪贴板');
    }
  };

  return (
    <div className="invite-page">
      <Breadcrumb items={breadcrumbItems} />
      <h1 className="page-title">邀请好友送积分</h1>

      <div className="invite-card">
        <div className="card-title">推荐好友，一起获得奖励！</div>
        <div className="card-description">
          通过邀请好友注册并充值，你们都可以获得积分奖励，邀请的好友越多奖励积分越多，快来邀请好友一起赚积分吧
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <div className="invite-row">
          <input
            className="invite-input"
            value={loading ? '正在加载...' : inviteUrl}
            readOnly
            placeholder="邀请链接生成中..."
          />
          <button
            className="btn primary"
            onClick={handleCopyLink}
            disabled={loading || !inviteUrl}
          >
            {loading ? '加载中...' : '来邀请吧'}
          </button>
        </div>

        <div className="activity-title">活动规则</div>

        <div className="rules">
          <div className="rule-item">
            <div className="rule-number">1</div>
            <div className="rule-content">
              <div className="rule-title">邀请好友充值</div>
              <div className="rule-description">
                好友充值积分或购买闲时会员后，双方均可获得积分奖励
                {/* ，每成功充值1元，双方各获得20积分；
                后续该好友的所有充值，你都可以获得同样的奖励，详见【<span className="link"><a href="https://uvetjcpbqd.feishu.cn/wiki/QXFBw6znQix2uCkvcNxc3Makncg" target="_blank" rel="noopener noreferrer">深锶数字人积分规则</a></span>】 */}
              </div>
            </div>
          </div>

          <div className="rule-item">
            <div className="rule-number">2</div>
            <div className="rule-content">
              <div className="rule-title">好友注册</div>
              <div className="rule-description">
                好友注册并成功登录，你和好友均可获得200积分奖励，多邀多得
              </div>
            </div>
          </div>
        </div>

        <div className="decor-left"></div>
        <div className="decor-right"></div>
      </div>
    </div>
  );
};

export default Invite;